import {MouseEvent} from 'react';
import {UrlLink} from '../../../../applink/UrlLink';
import {t} from '../../../../common/getTranslations';
import {Button} from '../../../../design-system/atoms/Button/Button';
import {
  ButtonColorScheme,
  ButtonSize,
} from '../../../../design-system/atoms/Button/Button.enum';
import {Icon} from '../../../../design-system/atoms/Icon/Icon';
import {IconType} from '../../../../design-system/atoms/Icon/IconType.enum';
import {Maybe} from '../../../../graphql/generated/types';
import {LOG_CLICK_EVENT} from '../../../../logging/logEvent';
import {AccountInfoBox} from './AccountInfoBox';

export interface InfoProps {
  nickname?: Maybe<string>;
  appUserId?: Maybe<string>;
  email?: Maybe<string>;
  thumbnail?: Maybe<string>;
  needProfileUpdate?: Maybe<boolean>;
  onClickProfile?: (e: MouseEvent) => void;
  onClickUnregister?: (e: MouseEvent) => void;
  onClickCopyUserId?: (e: MouseEvent) => void;
}

export function Info({
  nickname = '',
  appUserId = '',
  email = '',
  thumbnail = '',
  onClickProfile,
  onClickUnregister,
  onClickCopyUserId,
}: InfoProps) {
  return (
    <div className="font-medium2">
      <div
        className="relative m-auto mb-16pxr h-96pxr w-96pxr"
        onClick={e => LOG_CLICK_EVENT('프로필수정이미지_클릭', e)}
      >
        <UrlLink url="/account/profile">
          <img
            src={thumbnail || undefined}
            alt="프로필 사진"
            className="h-full w-full rounded-full object-cover"
          />
          {/* 썸네일 보더 */}
          <div className="absolute left-0 top-0 h-full w-full rounded-full border-[0.5px] border-solid border-static-transparent-black-05" />
        </UrlLink>
      </div>

      <AccountInfoBox
        className="cursor-pointer"
        description={t('more_account_info_nickname')}
        title={nickname || ''}
        rightButton={<Icon type={IconType.ListArrowRight} />}
        onClick={onClickProfile}
      />

      <AccountInfoBox
        description={t('more_account_info_member_number')}
        title={appUserId || ''}
        rightButton={
          <Button
            size={ButtonSize.Small}
            colorScheme={ButtonColorScheme['3rd']}
            onClick={onClickCopyUserId}
            className="rounded-xs bg-theme-solid-20"
          >
            {t('more_account_info_member_number_copy')}
          </Button>
        }
      />

      {email && (
        <AccountInfoBox
          description={t('more_account_info_kakao_account')}
          title={email}
        />
      )}

      <AccountInfoBox
        className="cursor-pointer"
        title={t('more_account_info_account_delete')}
        onClick={onClickUnregister}
        rightButton={<Icon type={IconType.ListArrowRight} />}
      />
    </div>
  );
}
